import { jsxs as e, jsx as n } from "react/jsx-runtime";
import { c as a } from "./index.CWkFp9WS.js";
import { memo as m } from "react";
import { O as S } from "./ODSBox.Dx8RRD-O.js";
import '../assets/ODSLoadingSpinner.css';const p = ({
  size: o = "large",
  labelAlignment: s = "vertical",
  labelText: i,
  accessibilityTitle: r,
  className: c,
  ...d
}) => {
  const l = a(
    "ODSLoadingSpinner",
    `ODSLoadingSpinner--labelAlignment-${s}`,
    c
  ), t = a(
    "ODSLoadingSpinner-Container",
    `ODSLoadingSpinner-ProgressIndicator--size-${o}`
  );
  return /* @__PURE__ */ e(S, { className: l, ...d, children: [
    /* @__PURE__ */ e(
      "svg",
      {
        className: t,
        viewBox: "0 0 100 100",
        "aria-hidden": "true",
        children: [
          /* @__PURE__ */ n(
            "circle",
            {
              r: "40",
              cx: "50",
              cy: "50",
              fill: "none",
              strokeWidth: "6",
              className: "ODSLoadingSpinner-Track"
            }
          ),
          /* @__PURE__ */ n(
            "circle",
            {
              r: "40",
              cx: "50",
              cy: "50",
              fill: "none",
              strokeWidth: "6",
              className: "ODSLoadingSpinner-ProgressIndicator"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ n("div", { className: "sr-only", "aria-live": "polite", children: r || i || "Loading" }),
    i ? /* @__PURE__ */ n("div", { id: "title", className: "ODSLoadingSpinner-Label", "aria-hidden": "true", children: i }) : null
  ] });
}, N = m(p);
export {
  N as O
};
//# sourceMappingURL=ODSLoadingSpinner.qaoMkU-3.js.map
